import { LDClient, initialize } from "launchdarkly-js-client-sdk";

let ldClient: LDClient | null = null;

export function initializeLDClient(
  clientSideID: string,
  user: { email?: string; companyId?: string } | null,
) {
  if (typeof window === "undefined") return null;

  if (!ldClient) {
    ldClient = initialize(
      clientSideID,
      user
        ? {
            kind: "multi",
            user: {
              key: user.email,
            },
            company: {
              key: user.companyId,
            },
          }
        : {
            kind: "user",
            key: "none",
          },
    );
  }

  return ldClient;
}

export function getLDClient() {
  return ldClient;
}
